import { render, staticRenderFns } from "./ListPlain.vue?vue&type=template&id=6c7221c9"
import script from "./ListPlain.vue?vue&type=script&lang=js"
export * from "./ListPlain.vue?vue&type=script&lang=js"
import style0 from "./ListPlain.vue?vue&type=style&index=0&id=6c7221c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports